import { useMutation, useQueryClient } from '@tanstack/react-query';

import { authApi, type SigninRequest } from '@/api/routes/public/auth.api';
import { translateFile } from '@/i18n';

export const useSignin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SigninRequest) => authApi.signin(data),
    meta: {
      showUserMessage: false,
      defaultUserMessage: translateFile('api.hooks.public.useSignin', 'error'),
    },
    onSuccess: () => {
      // Clear all queries from cache on signin
      queryClient.clear();
    },
  });
};
